import Icon from "@ant-design/icons";

import {Image} from "antd";
import {
    LiebIconImg
} from "../../../../assets";

export const MyIcon = (props) => <Image src={LiebIconImg} preview={false}/>
